<template>
    <div>
        <parameters
                ref="params"
                @input="onInput"
                :representative-options="representativeOptions"
        >
          <template v-slot:buttons>
            <el-button v-if="isDataLoaded" type="primary" @click="download" class="align-top">Download</el-button>
          </template>
        </parameters>
        <report-table
                :url="url"
                v-if="hasParams"
                v-show="isDataLoaded"
                :params="params"
                @success="onSuccess"
                @validation-error="onError"
        ></report-table>
    </div>
</template>

<script>
import ReportTable from './table';
import Parameters from './parameters';
import Download from "../../mixins/download";

export default {
    components: {
      ReportTable,
      Parameters,
    },

    mixins: [
      Download,
    ],

    props: {
      url: String,
      downloadUrl: String,
      representativeOptions: Array,
    },

    data() {
      return {
        params: null,
        isDataLoaded: false,
      }
    },

    computed: {
      /**
       * @return {Boolean}
       */
      hasParams() {
        return ! _.isEmpty(this.params);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      onInput(params) {
        this.params = params;
      },

      /**
       * @return {undefined}
       */
      onSuccess() {
        this.$refs.params.setErrors({});
        this.isDataLoaded = true;
      },

      /**
       * @param {objects} errors
       */
      onError(errors) {
        this.$refs.params.setErrors(errors);
        this.isDataLoaded = false;
      },

      download() {
        this.store({url: this.downloadUrl, data: this.params});
      },
    },
  }
</script>
